import CoursewareDefaultBlock from './CoursewareDefaultBlock.vue';
import CoursewareFileChooser from '../layouts/CoursewareFileChooser.vue';
import CoursewareFolderChooser from '../layouts/CoursewareFolderChooser.vue';
import CoursewareTabs from '../layouts/CoursewareTabs.vue';
import CoursewareTab from '../layouts/CoursewareTab.vue';
import CoursewareCompanionBox from '../layouts/CoursewareCompanionBox.vue'

import StudipFileChooser from './../../StudipFileChooser.vue';

const BlockComponents = {
    CoursewareDefaultBlock,
    CoursewareFileChooser,
    CoursewareFolderChooser,

    CoursewareTabs,
    CoursewareTab,
    CoursewareCompanionBox,

    StudipFileChooser,
}

export default BlockComponents;